import { CountryCode } from "./country-code";

export class Language {
    constructor(
        public Label: string,
        public CountryCode: CountryCode,
        public FlagCode: CountryCode = CountryCode

    ) { }

    public static fallBack(): Language {
        return english;
    }

    public static get(code: CountryCode): Language | undefined {
        return Language.List().find(language => language.CountryCode === code)
    }

    public static List(): Array<Language> {
        return Object.values(Languages)
    }
}

const english: Language = new Language("English (US)", CountryCode.English, CountryCode.UnitedStates);
const french: Language = new Language("Français", CountryCode.French);
const german: Language = new Language("Deutsch", CountryCode.German)

const Languages = {
    English: english,
    French: french,
    German: german
}